<template>
  <div>
    <b-modal id="show-modal-confirmacao" 
             centered
             size="lg"
             header-bg-variant="secondary"
             header-text-variant="white">
      <span class="h5">Qual o motivo da remoção de lançamento? </span><br>
      <textarea id="show-remocao-lancamento" 
                v-model="textArea" 
                rows="6" 
                cols="82"
                class="mt-1" />
      <template v-slot:modal-footer="{ close }">
        <button type="button"
                class="btn btn-close-modal pl-4 pr-4"
                @click="close()">
          Voltar
        </button>
        <button type="button"
                class="btn btn-secondary"
                @click="fecharModal(close)">
          Continuar
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'RemocaoLancamento',
    props: {
      atualizacaoDeLancamentos: {
        type: Array,
        default: Array,
      },
      atualizarLancamentosDeRecebimentos: {
        type: Array,
        default: Array,
      },
      atualizarLancamentosDePagamentos: {
        type: Array,
        default: Array,
      }
    },
    data () {
      return {
        textArea: '',
      }
    },
    destroyed () {
      this.textArea = ''
    },
    methods: {
      fecharModal (close) {
        if (this.atualizacaoDeLancamentos[1] === 'todos') {
          this.atualizacaoDeLancamentos[0]()
          this.$emit('mensagem', this.textArea)
        
        }

        if (this.atualizarLancamentosDeRecebimentos[1] === 'recebimentosAvulsos') {
          this.atualizarLancamentosDeRecebimentos[0]()
          this.$emit('mensagem', this.textArea)
        }

        if (this.atualizarLancamentosDePagamentos[1] === 'pagamentosAvulsos') {
          this.atualizarLancamentosDePagamentos[0]()
          this.$emit('mensagem', this.textArea)
        }
        close()
      }
    }
  }
</script>

<style>

</style>